document.addEventListener('click', (event) => {
  document.querySelectorAll('.ww-water-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.ww-water-menu[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
document.querySelectorAll('.ww-water-menu').forEach(menu => {
  menu.addEventListener('toggle', () => {
    if (!menu.open) return;
    menu.closest('.ww-water-nav').querySelectorAll('.ww-water-menu').forEach(other => {
      if (other !== menu) other.open = false;
    });
  });
});
